import { useToast } from '@chakra-ui/react'
import { useSwitchChain } from 'wagmi'
import { useWeb3 } from './useWeb3'

export const useAddBahamut = () => {
  const { switchChainAsync } = useSwitchChain()
  const { chain } = useWeb3()

  const toast = useToast()
  const onSuccess = () => {
    toast({
      title: 'Success',
      description: `Switched to ${chain?.name} Network!`,
      status: 'success',
      duration: 9000,
      isClosable: true,
    })
  }

  const addBahamut = async () => {
    await switchChainAsync({ chainId: chain?.id }, { onSuccess })
  }

  return {
    addBahamut,
  }
}
